import styled, { css } from 'styled-components';
import store from '@/store';
import { SMARTPHONE } from '@/constants';

export const HeaderWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  align-items: center;
  grid-template-columns: 48px 1fr auto;
  font-family: Lato;
  font-size: inherit;
  padding: 12px 0 0 0;
  
  ${props => {
    const { core: { targetDevice } } = store.getState();

    switch (targetDevice) {
      case SMARTPHONE: {
        return css`
          grid-template-columns: 48px 1fr min-content;
        `;
      }
      default: {
        return null;
      }
    }
  }}
`;

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 2px;
  font-size: 1.125em;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  cursor: pointer;
`;

export const LabelWrapper = styled.div`
  display: flex;
  font-size: 1.125em;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.43px;
  color: #030303;

  ${props => {
    const { core: { targetDevice } } = store.getState();

    switch (targetDevice) {
      case SMARTPHONE: {
        return css`
          display: inline-block;
          overflow: hidden;
          max-width: 100%;
          white-space: nowrap;
          text-overflow: ellipsis;
        `;
      }
      default: {
        return null;
      }
    }
  }}
`;
